import { defineRecipe } from '@chakra-ui/react/styled-system';

const linkRecipe = defineRecipe({
  className: 'link',
  base: {
    color: 'currentcolor',
    _hover: {
      textDecoration: 'underline',
    },
    _disabled: {
      color: 'text/disabled !important',
      cursor: 'not-allowed',
      textDecoration: 'none !important',
    },
    '&:has(svg)': {
      display: 'inline-flex',
      gap: '4',
      alignItems: 'center',
    },
  },
  variants: {
    colorVariant: {
      purple: {
        color: 'text/link',
        _hover: {
          color: 'text/link-hover',
        },
      },
    },
  },
});

export default linkRecipe;
